import React from 'react';
import styles from './DeleteTransportBtn.module.scss';
import useDeleteTransport from './api/useDeleteTransport';
import useTransportCheckPermit from '../../queries/useTransportCheckPermit';
import { ReactComponent as ButtonDeleteIcon } from './ButtonDeleteIcon.svg';
import { Modal } from 'antd';

const confirm = Modal.confirm;

const DeleteTransportBtn = ({
  clientId,
  addressId,
  transportId,
  companyId,
  renderItem,
  onSuccess,
  disabled = false,
  transport,
}) => {
  const { deleteTransport, isLoading: isLoadingDeleteTransport } =
    useDeleteTransport();
  const { mutateAsync: checkPermit, isLoading: isLoadingCheck } =
    useTransportCheckPermit();

  const isLoading = isLoadingDeleteTransport || isLoadingCheck;

  const handleDelete = async (e) => {
    e.stopPropagation();

    const data = await checkPermit({ transportId, clientId, companyId });

    confirm({
      title: `Удалить транспортное средство: ${transport?.country?.name}, ${transport?.number} ${transport?.region},  ${transport?.brand} ${transport?.model} в рамках компании?`,
      content: `${
        !data.success
          ? 'На транспортное средство есть активные пропуска. После удалении ТС все пропуска в рамках компании будут аннулированы!'
          : ''
      }`,
      onOk: async () => {
        await deleteTransport({
          clientId,
          addressId,
          transportId,
          onSuccess,
        });
      },
      onCancel() {},
      okText: 'Удалить',
    });
  };

  if (typeof renderItem === 'function') {
    return renderItem({
      onDelete: handleDelete,
      isLoading,
      disabled: disabled || isLoading,
    });
  }

  return <ButtonDeleteIcon onClick={handleDelete} className={styles.baseBtn} />;
};
export default DeleteTransportBtn;
